var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.83 5H5.17l6.5 5.71a.49.49 0 0 0 .66 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.67 13.71 2 5.22v12.53A1.25 1.25 0 0 0 3.25 19h17.5A1.25 1.25 0 0 0 22 17.75V5.22l-9.67 8.49a.49.49 0 0 1-.66 0Z"
})));
export default SvgMail;